import { type SdmModuleSpecsFragment } from '../../../../../api/fragments/SdmModuleSpecs';
import UpdateSalesPersonCodeMappingForm from './UpdateSalesPersonCodeMappingForm';

type SalesPersonCodeMappingsProps = {
    module: SdmModuleSpecsFragment;
};

const SalesPersonCodeMappings = ({ module }: SalesPersonCodeMappingsProps) => (
    <UpdateSalesPersonCodeMappingForm module={module} />
);
export default SalesPersonCodeMappings;
